module.exports = __webpack_public_path__ + "static/img/jolt-logo.fd4553b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jolt-logo.png
// module id = jYh6
// module chunks = 1